$(window).load(function(){
	banner_carousel();
  	matchHeight();
});
$(document).ready(function(){
	banner_carousel();
  	matchHeight();
});


/*
	Variable Functions ==========================================================
*/
function matchHeight() {
  jQuery('.product-card__title').matchHeight();
  jQuery('.matchthis').matchHeight();
  jQuery('.article__grid-image-container').matchHeight();
  jQuery('.article__title').matchHeight();
  jQuery('.rte article__grid-excerpte').matchHeight();
  jQuery('.product-card__image-wrapper').matchHeight();
  jQuery('.product-card__image-with-placeholder-wrapper').matchHeight();
  
  console.log("matchHeightisWorking");
}

function banner_carousel(){
	$('.banner-carousel').owlCarousel({
		loop:true,
		nav: false,
        margin:25,
        dots:true,
		navText: ["<i class='fa fa-arrow-left' aria-hidden='true'></i>", "<i class='fa fa-arrow-right' aria-hidden='true'></i>"],
		responsiveClass:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
        autoplay:true,
        dots:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}



